import type { Author } from 'interfaces/content/Authors';
import BylineList from 'components/Byline';
import VodVideo from 'components/VodVideo';
import { NextCustomImage } from 'components/Image';
import type { MediaItem } from 'interfaces/content/Media';
import ImageCaption from 'components/ImageCaption';
import StnVideo from 'components/StnVideo';
import { parseCaptionWhenAltTextEmpty } from 'utils/parsingUtils/clientSideParsing';
import {
  Hero,
  Wrapper,
  Container,
  Title,
  DekContainer,
  Dek,
  AuthorsContainer,
  Authors,
  Date,
  ImageContainer,
  VideoContainer,
} from './LongformHeroStyles';

export interface LogformHeroProps {
  heroLayout: 'landscape' | 'portrait' | 'full_bleed';
  title: string;
  postSettingsDek: string;
  audienceDek: string;
  description: string;
  authors: Author[];
  localDate: string | null;
  mediaType: string;
  videoId: string;
  mediaItem: MediaItem;
}

const LongformHero = ({
  heroLayout,
  title,
  postSettingsDek,
  audienceDek,
  description,
  authors,
  localDate,
  mediaType,
  videoId,
  mediaItem,
}: LogformHeroProps) => (
  <Hero>
    <Wrapper
      id='hero'
      className={heroLayout}
    >
      <Container className={heroLayout}>
        <Title
          className={heroLayout}
          as='h1'
          $fontFamily='saol'
          $size={{ default: 'level2', mdMin: 'large' }}
        >
          {title}
        </Title>
        <DekContainer className={`${heroLayout} ${mediaType}`}>
          <Dek className={heroLayout}>{postSettingsDek || audienceDek || description}</Dek>
          <AuthorsContainer>
            <Authors>
              <BylineList
                bylineList={authors}
                isArticle
              />
            </Authors>
          </AuthorsContainer>
          <Date>{localDate}</Date>
        </DekContainer>
      </Container>
      {mediaType === 'image' && (
        <ImageContainer className={heroLayout}>
          {(!heroLayout || heroLayout === 'landscape') && (
            <NextCustomImage
              alt={parseCaptionWhenAltTextEmpty(mediaItem)}
              src={mediaItem.mediaItemUrl}
              width='1020'
              height='680'
              priority
            />
          )}
          {heroLayout === 'portrait' && (
            <NextCustomImage
              alt={parseCaptionWhenAltTextEmpty(mediaItem)}
              src={mediaItem.mediaItemUrl}
              width='814'
              height='1221'
              priority
            />
          )}
          {heroLayout === 'full_bleed' && (
            <NextCustomImage
              alt={parseCaptionWhenAltTextEmpty(mediaItem)}
              src={mediaItem.mediaItemUrl}
              width='1440'
              height='960'
              priority
            />
          )}
          {(mediaItem.caption || mediaItem.credit) && (
            <ImageCaption
              caption={mediaItem.caption}
              credit={mediaItem.credit}
              className={heroLayout}
            />
          )}
        </ImageContainer>
      )}
      {mediaType === 'fortune_video' && (
        <VideoContainer>
          <VodVideo videoId={videoId} />
        </VideoContainer>
      )}
      {mediaType === 'stn_fortune_video' && (
        <VideoContainer>
          <StnVideo videoId={videoId} />
        </VideoContainer>
      )}
    </Wrapper>
  </Hero>
);

export default LongformHero;
